/**
 * @generated SignedSource<<ecac2652be44856880d61ee2a4dd2d85>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type OrganizationRole = "ADMIN" | "MEMBER" | "OWNER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type InvitationHeaderFragment$data = {
  readonly email: string;
  readonly inviterName: string;
  readonly organizationName: string;
  readonly role: OrganizationRole;
  readonly " $fragmentType": "InvitationHeaderFragment";
};
export type InvitationHeaderFragment$key = {
  readonly " $data"?: InvitationHeaderFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"InvitationHeaderFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InvitationHeaderFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "role",
        "storageKey": null
      },
      "action": "THROW"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "inviterName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "organizationName",
      "storageKey": null
    }
  ],
  "type": "Invitation",
  "abstractKey": null
};

(node as any).hash = "d68d69afa862dcf12bf4771adda43f68";

export default node;
